/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Provider } from '@angular/core';
import { AccountSummaryService } from './account-summary.service';
import {AccountSummaryFacade} from "../../root/facade";

export const facadeProviders: Provider[] = [
  AccountSummaryService,
  {
    provide: AccountSummaryFacade,
    useExisting: AccountSummaryService,
  },
];
